import axiosClient from "axiosClient";
import axiosClientStilo from "axiosClient/indexStilo";
import { getQueryString } from "utilities/common";
import { STILO } from "utilities/constants";
import axiosClientPromotion from "axiosClient/indexPromotion";
const adminsMode = JSON.parse(localStorage.getItem('adminsMode'))

export async function fetchRegionsAPI(filters) {
    return await (adminsMode === STILO ? axiosClientStilo : axiosClient).get(`/api/v1/admin/region/get?${getQueryString(filters)}`);
}
export async function addRegionAPI(data) {
    return await (adminsMode === STILO ? axiosClientStilo : axiosClient).post(`/api/v1/admin/region`, data);
}

export async function updateRegionId(data, regionId) {
    return await (adminsMode === STILO ? axiosClientStilo : axiosClient).put(`/api/v1/admin/region/update/${regionId}`, data);
}

export async function deleteRegionAPI(regionId) {
    return await (adminsMode === STILO ? axiosClientStilo : axiosClient).delete(`/api/v1/admin/region/${regionId}`);
}

export async function fetchRegionDetailsAPI(regionId) {
    return await (adminsMode === STILO ? axiosClientStilo : axiosClient).get(`/api/v1/admin/region/${regionId}`);
}

export async function fetchRegionListingAPI(filters) {
    return await axiosClientPromotion.get(`/api/v1/admin/listing/region?${getQueryString(filters)}`);
}